export default {
    AppHeader: {
        language: 'Translations',
        languageTooltip: 'Select a language',
        languageSwitchedMessage: 'Language switched to {0} successfully.'
    }
};
